import React from "react";
import { connect } from "react-redux";
import { ACTION_TYPE } from "reducers/actionType";

import CustomRadioGroup from "components/personality/CustomRadioGroup";
import NavigationFooter from "components/footers/NavigationFooter";
import { isPopulated, getCategory } from "utils/helpers";
import { makePersonalitySelector } from "reducers/selectors";

class Personality extends React.Component {
  componentDidMount = () => {
    window.scrollTo(0, -100);
  };
  handleClickRadio = (groupId, id) => {
    this.props.dispatch({
      type: ACTION_TYPE.PERSONALITY.TOGGLE,
      data: { personality_attribute: groupId, personality_type: id },
    });
  };

  clearAll = () => {
    this.props.dispatch({
      type: ACTION_TYPE.PERSONALITY.RESET,
    });
  };

  render() {
    const { userPersonality, personalityList } = this.props;
    const personalityChoicesOb = userPersonality.reduce((ob, next) => {
      const { personality_type, personality_attribute } = next;
      ob[personality_attribute] = personality_type;
      return ob;
    }, {});

    return (
      <>
        <div className="regular-padding">
          <h1>What working environment best suits you?</h1>

          <p>Select one (or none) from each category</p>

          {personalityList.map((attribute, i) => {
            const { personality_attribute, personality_type } = attribute;
            return (
              <CustomRadioGroup
                key={personality_attribute}
                heading={personality_attribute}
                choices={personality_type}
                value={personalityChoicesOb[personality_attribute]}
                onClickRadio={this.handleClickRadio}
                last={i === personalityList.length - 1}
              />
            );
          })}
        </div>
        <NavigationFooter
          enable={isPopulated(getCategory("Personality"))}
          nextNavlink={getCategory("Career").navlink}
          onSkip={this.clearAll}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => (store) => makePersonalitySelector()(store);

export default connect(mapStateToProps)(Personality);
